// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.properties.addresses.RentalManagerAddressAutocompleteWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAddressAutocompleteWebApiHandler_autocomplete,
  RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { RentalManagerAddressAutocompleteWebResponseDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

interface AutocompleteParams {
  partialAddress: string;
}

export type RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Options = UseQueryOptions<
  RentalManagerAddressAutocompleteWebResponseDto,
  unknown,
  RentalManagerAddressAutocompleteWebResponseDto,
  readonly [string, AutocompleteParams]
>;

const RentalManagerAddressAutocompleteWebApiHandler_autocomplete_GetKey = (getParams: AutocompleteParams) =>
  [RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Path, getParams] as const;

export const RentalManagerAddressAutocompleteWebApiHandler_autocomplete_queryOptions = (
  getParams: AutocompleteParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAddressAutocompleteWebApiHandler_autocomplete_GetKey(getParams),
    queryFn: () => RentalManagerAddressAutocompleteWebApiHandler_autocomplete(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get autocomplete addresses for a partial address
 */
export const useRentalManagerAddressAutocompleteWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAddressAutocompleteWebApiHandler_autocomplete_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAddressAutocompleteWebApiHandler_autocomplete_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAddressAutocompleteWebApiHandler_autocomplete.getKey =
  RentalManagerAddressAutocompleteWebApiHandler_autocomplete_GetKey;
